// 3D stack floors are `floorplans` reversed; `start` is 0-based into that stack.
// Level 1 (start 0) is the last sidebar item — the bottom of the stack.

export const startingFloorUuid = (floorplans, start = 0) => {
  if (!floorplans?.length) return null;
  const index =
    Number.isInteger(start) && start >= 0 && start < floorplans.length
      ? start
      : 0;
  return floorplans[floorplans.length - 1 - index]?.uuid ?? null;
};
